import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41bbb456"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tutorial-row" }
const _hoisted_2 = { class: "topic" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "comment" }

import { ref } from 'vue'
import ButtonComponent from '@/components/UI/ButtonComponent.vue'
import MicrogestureComponent from '@/components/Microgesture/MicrogestureComponent.vue'


export default {
  __name: 'TutorialRow',
  props: {
  topic: String,
  microgesture: Object,
  comment: String
},
  setup(__props) {



const displayAnswer = ref(false)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(__props.topic), 1),
      _createVNode(ButtonComponent, {
        class: "text",
        onClick: _cache[0] || (_cache[0] = $event => (displayAnswer.value = !displayAnswer.value))
      }, {
        default: _withCtx(() => [
          (!displayAnswer.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Show")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Hide")
              ], 64)),
          _createTextVNode(" the answer ")
        ]),
        _: 1
      })
    ]),
    (displayAnswer.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(MicrogestureComponent, { "model-value": __props.microgesture }, null, 8, ["model-value"]),
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.comment), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}